// 卫生强基 - 基层巡讲文章数据
// 定义文章类型接口
export interface WeishengArticle {
  id: number;
  title: string;
  link: string;
  date: string;
  type: string;
}
export const weishengArticles = [
  {
    id: 1,
    title: '不远万里奔赴边疆、深入基层服务群众—山东省神经科学学会2025年“鲁喀医心”对口支援行动走进新疆喀什',
    link: 'https://mp.weixin.qq.com/s/ow-5g0uWFF8sjS2la-TCVQ',
    date: '2025-08-22',
    type: 'jicengxunjiang',
  },
  {
    id: 2,
    title: '我会“卒中新语”系列培训活动在全省多地举办',
    link: 'https://mp.weixin.qq.com/s/wPyUoG8V_DEHFMmFifw5Hw',
    date: '2025-09-08',
    type: 'jicengxunjiang',
  },
  {
    id: 3,
    title: '山东省神经科学学会神经内科领域相关性疾病规范化诊疗巡讲走进日照',
    link: 'https://mp.weixin.qq.com/s/naVRwYs5aGSHdmwXXiQLgQ',
    date: '2025-08-14',
    type: 'jicengxunjiang',
  },
  {
    id: 4,
    title: '我会“卒中新语”系列培训活动在全省多地举办',
    link: 'https://mp.weixin.qq.com/s/Ex21NmM_AcCKpUq58d35QA',
    date: '2025-08-11',
    type: 'jicengxunjiang',
  },
  {
    id: 5,
    title: '我会“卒中新语”系列培训活动分别在聊城、烟台、济南举办',
    link: 'https://mp.weixin.qq.com/s/KLbt-92tcE6-zFt_2Fv4PA',
    date: '2025-07-04',
    type: 'jicengxunjiang',
  },
    {
    id: 6,
    title: '我会以多学科协作模式开展的阿尔茨海默病精准医疗系列学术会议第三期在淄博举办',
    link: 'https://mp.weixin.qq.com/s/c6x-bbfQchigXJxxOAF0sg',
    date: '2025-07-15',
    type: 'jicengxunjiang',
  },
];
// 获取所有基层巡讲文章
export const getJicengxunjiangArticles = (): WeishengArticle[] => {
  return weishengArticles
    .filter(article => article.type === 'jicengxunjiang')
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

// 获取最新的基层巡讲文章（用于首页显示）
export const getLatestJicengxunjiangArticles = (limit = 5): WeishengArticle[] => {
  return getJicengxunjiangArticles().slice(0, limit);
};